import { FileModel } from '@zocks-communications/client-sdk-js'
import { FileKind } from '../../../models/File'

export const isEnhancedAllocatedSessionTranscription = (file: FileModel) => {
  const fileMetadata = JSON.parse(file.metadata)
  return file.kind === FileKind.TRANSCRIPTION && fileMetadata.transcriptionType === 'session' && fileMetadata.enhanced && !fileMetadata.unknownParticipants
}
